// extracted by mini-css-extract-plugin
export default {"container":"OrderPositionsTableOrderId_container__W+j9S","link":"OrderPositionsTableOrderId_link__xp-Wg","link--moderation":"OrderPositionsTableOrderId_link--moderation__WoIla"};